import React, { Component, PropTypes } from 'react';
import { Colors, Shadow, Units } from 'Css';
import classNames from 'classnames';

const css = oxygenCss({
  root: {
    '&fixed': {
      position: 'absolute',
      left: 0,
      right: 0
    },
    '&bottom': {
      bottom: 0
    },
    '&top': {
      top: 0
    },
    zIndex: 2,
    '&depth0': {},
    '&depth1': {
      boxShadow: `${Shadow[1]}`
    },
    '&depth2': {
      boxShadow: `${Shadow[2]}`
    },
    '&depth3': {
      boxShadow: `${Shadow[3]}`
    },
    '&depth4': {
      boxShadow: `${Shadow[4]}`
    },
    '&depth5': {
      boxShadow: `${Shadow[5]}`
    }
  },
  toolbar: {
    padding: Units.base,
    minHeight: Units.keyline,
    boxSizing: 'border-box',
    display: '-webkitFlex',
    display: '-mozFlex',
    display: '-msFlexbox',
    display: '-oFlex',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-start',
    flexWrap: 'wrap',
    alignItems: 'stretch',
    alignContent: 'stretch',
    flexGrow: 1,
    flexShrink: 1,
    alignSelf: 'stretch',
    '&dense': {
      padding: Units.base / 2,
      minHeight: Units.base * 6
    },
    '&center': {
      margin: 'auto'
    }
  }
});

class Toolbar extends Component {
  static propTypes = {
    color: PropTypes.string,
    children: PropTypes.node,
    center: PropTypes.bool,
    fixed: PropTypes.bool,
    top: PropTypes.bool,
    bottom: PropTypes.bool,
    transparent: PropTypes.bool,
    dense: PropTypes.bool,
    zDepth: PropTypes.number
  };

  static defaultProps = {
    zDepth: 0
  };

  render() {
    const {
      children,
      dense,
      top,
      zDepth,
      bottom,
      fixed,
      transparent,
      color,
      center,
      ...other
    } = this.props;
    const classes = classNames(css.root, css['depth' + zDepth], {
      [css.top]: top,
      [css.bottom]: bottom,
      [css.fixed]: fixed
    });
    const backgroundColor = transparent
      ? null
      : color ? color : Colors.material.grey[200].hex;
    return (
      <div className={classes} style={{ backgroundColor }} {...other}>
        <div
          className={classNames(css.toolbar, {
            [css.center]: center,
            [css.dense]: dense
          })}
        >
          {children}
        </div>
      </div>
    );
  }
}

export default Toolbar;



// WEBPACK FOOTER //
// ./src/js/Cio/Toolbar/Toolbar.js